import { DomainEvent } from "@/domains/events"

export class VenammSupplyUpdatedEvent extends DomainEvent {
  readonly type = "venamm.supply-updated"

  constructor(
    public readonly availableTokenSupply: bigint,
    public readonly availableTokenSupplyValue: number,
  ) {
    super()
  }
}

